import { render, staticRenderFns } from "./ownershipStructure.vue?vue&type=template&id=6a3dc070&"
import script from "./ownershipStructure.vue?vue&type=script&lang=js&"
export * from "./ownershipStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports